import { Component, Inject, ElementRef,ViewChild, Optional, OnInit,Injectable, Input } from '@angular/core';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MarcoDeReferencia } from 'app/main/models/marco-de-referencia.model';
import { Sentencia } from 'app/main/models/sentencia.model';
import { TipoEvaluacion } from 'app/main/models/tipo-evaluacion.model';
import {SelectionModel} from '@angular/cdk/collections';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import {BehaviorSubject} from 'rxjs';
import {COMMA, ENTER} from '@angular/cdk/keycodes';

import { DialogBoxChangeFatherComponent } from './dialog-box-change-father.component';
import { MarcoDeReferenciaService } from 'app/main/services/marco-de-referencia.service';
import {FormControl} from '@angular/forms';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

import { DialogBoxComponent } from './dialog-box.component';
import {TranslateService} from '@ngx-translate/core';
import { DialogBoxAddNodeComponent } from './dialog-box-add-node.component';
import { UtilsService } from '../../../services/utils.service';
import { TablaDeEvaluacion } from 'app/main/models/tabla-de-evaluacion.model';
import { TablaDeEvaluacionService } from 'app/main/services/tabla-de-evaluacion.service';
import { Router } from '@angular/router';


/** Flat to-do item node with expandable and level information */
export class TodoItemFlatNode {
  valor: Sentencia;
  nombre: string;
  descripcion: string;
  tablaDeEvaluacion: TablaDeEvaluacion;
  level: number;
  expandable: boolean;
  editable: boolean;
}

var tablasEvaluacion: TablaDeEvaluacion[] = [];

/**
 * Checklist database, it can build a tree structured Json object.
 * Each node in Json object represents a to-do item or a category.
 * If a node is a category, it has children items and new items can be added under the category.
 */
@Injectable()
export class ChecklistDatabase {
  dataChange = new BehaviorSubject<Sentencia[]>([]);
  


  get data(): Sentencia[] { return this.dataChange.value; }

  constructor(public dialog: MatDialog,
             public utils:UtilsService) {
    this.initialize();
  }

  initialize() {
    // Build the tree nodes from Json object. The result is a list of `TodoItemNode` with nested
    //     file node as children.
    const data = this.buildFileTree([], 0);

    // Notify the change.
    this.dataChange.next(data);
  }

  setData(dataSet){
    //const data = this.buildFileTree(dataSet,0);
    this.dataChange.next(dataSet);
  }

  /**
   * Build the file structure tree. The `value` is the Json object, or a sub-tree of a Json object.
   * The return value is the list of `TodoItemNode`.
   */
  buildFileTree(obj: {[key: string]: any}, level: number): Sentencia[] {
    return Object.keys(obj).reduce<Sentencia[]>((accumulator, key) => {
      const value = obj[key];
      const node = new Sentencia({});
      node.nombre = key;
      node.level = level;

      if (value != null) {
        if (typeof value === 'object') {
          node.sentencias = this.buildFileTree(value, level + 1);
        } else {
          node.nombre = value;
        }
      }

      return accumulator.concat(node);
    }, []);
  }


  insertItem(parent: Sentencia, nodo: Sentencia,treeControl,node) {

    const dialogRef = this.dialog.open(DialogBoxAddNodeComponent, {
      width: '100%',
      data: {action:'Add',obj:nodo, tablas: tablasEvaluacion},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {

      if(result.event=='Add'){
        nodo = result.data;
        if (parent.sentencias) {
          parent.sentencias.push(nodo);
          parent.sentencias.sort(this.utils.sortAlphaNum);
          //parent.sentencias.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
          this.dataChange.next(this.data);
        }else{
          parent.sentencias = [];
          parent.sentencias.push(nodo);
          parent.sentencias.sort(this.utils.sortAlphaNum);
          //parent.sentencias.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
          this.dataChange.next(this.data);
        }

        treeControl.expand(node);
      }
    });

  }

  removeItem(parent: Sentencia, nodo: Sentencia) {
    if (parent.sentencias) {
      var posicion = 0;
      for(var i=0;i<parent.sentencias.length;i++){
        if(parent.sentencias[i].nombre === nodo.nombre){
          posicion = i;
          break;
        }
      }
      parent.sentencias.splice(posicion, 1);
      //parent.sentencias.push(nodo);
      this.dataChange.next(this.data);
    }
  }

  insertRootItem() {
    var nodo = new Sentencia({});

    const dialogRef = this.dialog.open(DialogBoxAddNodeComponent, {
      width: '100%',
      data: {action:'Add',obj:nodo, tablas: tablasEvaluacion},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {

      if(result.event=='Add'){
        nodo = result.data;
        this.data.push(nodo);
        this.data.sort(this.utils.sortAlphaNum);
        //this.data.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
        this.dataChange.next(this.data);
      }

    });

  }

  updateItem(node: TodoItemFlatNode, nodo: Sentencia,dataSource:any) {
    var nodo_clone:Sentencia = new Sentencia(nodo);
    const dialogRef = this.dialog.open(DialogBoxAddNodeComponent, {
      width: '100%',
      data: {action:'Update',obj:nodo, tablas: tablasEvaluacion},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.event=='Update'){
        //nodo = result.data;
        node.valor = nodo;
        node.nombre = nodo.nombre;
        node.tablaDeEvaluacion = nodo.tablaDeEvaluacion;
        node.descripcion = nodo.descripcion;
        node.editable = nodo.editable || false;
        nodo.sentencias.sort(this.utils.sortAlphaNum);
        //nodo.sentencias.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
        this.dataChange.next(this.data);
        this.orderStructure(dataSource.data);
        dataSource.data = [...dataSource.data];
      }else{
        nodo.nombre = nodo_clone.nombre;
        nodo.descripcion = nodo_clone.descripcion;
        nodo.tablaDeEvaluacion = nodo_clone.tablaDeEvaluacion;
      }
    });
  }

  orderStructure(nodos):void{
      for(var z=0; nodos.length>z;z++){
        nodos.sort(this.utils.sortAlphaNum);
        //nodos.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
        this.orderStructure(nodos[z].sentencias);
      }
    }


}

@Component({
  selector: 'app-dialog-box-tree',
  templateUrl: './dialog-box-tree.component.html',
  styleUrls: ['./dialog-box-tree.component.scss'],
  providers: [ChecklistDatabase]
})
export class DialogBoxTreeComponent {

  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  flatNodeMap = new Map<TodoItemFlatNode, Sentencia>();

  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  nestedNodeMap = new Map<Sentencia, TodoItemFlatNode>();

  /** A selected parent node to be inserted */
  selectedParent: TodoItemFlatNode | null = null;

  /** The new item's name */
  newItemName = '';

  treeControl: FlatTreeControl<TodoItemFlatNode>;

  treeFlattener: MatTreeFlattener<Sentencia, TodoItemFlatNode>;

  dataSource: MatTreeFlatDataSource<Sentencia, TodoItemFlatNode>;

  /** The selection for checklist */
  checklistSelection = new SelectionModel<TodoItemFlatNode>(true /* multiple */);
  action: string;
  newNode:Sentencia = new Sentencia({});
  estructura: MarcoDeReferencia = null;
  original: MarcoDeReferencia = null;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  //lastTypedPolitica:string ="";
  //filteredPoliticas: Observable<MarcoDeReferencia[]>;
  myControl = new FormControl();
  //politicas: MarcoDeReferencia[] = [];

  @Input() tipo: string = 'ANALISIS_DE_BRECHAS';
  @Input() title: string = 'marco de referencia';
  href: string = "";

  @ViewChild('usuarioInput') usuarioInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor(
    public service:MarcoDeReferenciaService,
    private _database: ChecklistDatabase,
    public dialog: MatDialog,
    public translate: TranslateService,
    public utils:UtilsService,
    public serviceTablasEvaluacion: TablaDeEvaluacionService,
    public router: Router,
    public dialogRef: MatDialogRef<DialogBoxTreeComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {

    console.log(data);
    this.dialogRef.disableClose = true;
    this.estructura = this.deepCopy(data.info);
    this.original = data.info;
    this.estructura.sentencias = this.estructura.sentencias || [];
    this.orderStructure(this.estructura.sentencias);
    _database.setData(this.estructura.sentencias);
    this.action = data.action;

    this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel,
      this.isExpandable, this.getChildren);
    this.treeControl = new FlatTreeControl<TodoItemFlatNode>(this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    _database.dataChange.subscribe(data => {
      this.dataSource.data = data;
    });

    this.href = this.router.url;
      //Es Debida diligencia
      if(this.href.indexOf('debida-diligencia')!=-1){
        this.tipo = "DEBIDA_DILIGENCIA";
        this.title = "formulario debida diligencia";
      }
  }

  doAction(): void{
    console.log('im here');
    var prettyData = this.cleanStructure(this.dataSource.data);
    this.dialogRef.close({event: this.action, data: prettyData});
  }

  closeDialog(): void{
    //this.dialogRef.close({event: 'Cancel'});
    this.dialogRef.close({event: 'Cancel',data:this.original});
  }

  cleanStructure(nodo):Sentencia[]{
    var estructura = [];

    for(var z=0; nodo.length>z;z++){
      var nodo_limpio = new Sentencia({});

      nodo_limpio.id  = (nodo[z].valor!=null) ? nodo[z].valor.id:nodo[z].id;
      nodo_limpio.nombre  = (nodo[z].valor!=null) ? nodo[z].valor.nombre:nodo[z].nombre;
      nodo_limpio.descripcion  = (nodo[z].valor!=null) ? nodo[z].valor.descripcion:nodo[z].descripcion;
      nodo_limpio.tablaDeEvaluacion  = (nodo[z].valor!=null) ? nodo[z].valor.tablaDeEvaluacion:nodo[z].tablaDeEvaluacion;
      if('sentencias' in nodo[z])
        nodo_limpio.sentencias = this.cleanStructure(nodo[z].sentencias);

      estructura.push(nodo_limpio)
    }

    return estructura;

  }

  ngOnInit(): void {

    if(this.tipo == "DEBIDA_DILIGENCIA")
      this.serviceTablasEvaluacion.getList(this.tipo).pipe().subscribe(req => {
        tablasEvaluacion = req.body.map( tabla => {
          return tabla;
        });
        // add to the position 0 a new item to tablasEvaluacion
        //tablasEvaluacion.splice(0, 0, new TablaDeEvaluacion({id:0,nombre:"Texto libre", descripcion: "Texto libre",tipoFiltro:"DEBIDA_DILIGENCIA", "tipo":"EVALUACION_SIMPLE", subtipo: "CUMPLE_NO_CUMPLE"}));
      });
      
  }

  deepCopy(obj) {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = this.deepCopy(obj[i]);
        }
        return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = this.deepCopy(obj[attr]);
        }
        return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
}

  /*
   public agregarPolitica():void{
     const dialogRef = this.dialog.open(DialogBoxComponent, {
       width: '100%',
       data: {obj:{nombre:this.lastTypedPolitica},action:'Add',dataSource:this.politicas}
     });

     dialogRef.afterClosed().subscribe(result => {
       this.politicas = [...result.dataSource];
       this.newNode.politica = {...result.data};

     });
  }*/


  getLevel = (node: TodoItemFlatNode) => node.level;

  isExpandable = (node: TodoItemFlatNode) => node.expandable;

  getChildren = (node: Sentencia): Sentencia[] => node.sentencias;

  hasChild = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.expandable;

  hasNoContent = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.nombre === '' || _nodeData.editable;

  /**
   * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
   */
  transformer = (node: Sentencia, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode = existingNode && existingNode.nombre === node.nombre
        ? existingNode
        : new TodoItemFlatNode();
    flatNode.nombre = node.nombre;
    flatNode.valor = new Sentencia(node);
    flatNode.level = level;
    flatNode.expandable = !!node.sentencias?.length;
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  }

  /** Whether all the descendants of the node are selected. */
  descendantsAllSelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.length > 0 && descendants.every(child => {
      return this.checklistSelection.isSelected(child);
    });
    return descAllSelected;
  }

  /** Whether part of the descendants are selected */
  descendantsPartiallySelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child => this.checklistSelection.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }

  /** Toggle the to-do item selection. Select/deselect all the descendants node */
  todoItemSelectionToggle(node: TodoItemFlatNode): void {
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);

    // Force update for the parent
    descendants.forEach(child => this.checklistSelection.isSelected(child));
    this.checkAllParentsSelection(node);
  }

  /** Toggle a leaf to-do item selection. Check all the parents to see if they changed */
  todoLeafItemSelectionToggle(node: TodoItemFlatNode): void {
    this.checklistSelection.toggle(node);
    this.checkAllParentsSelection(node);
  }

  /* Checks all the parents when a leaf node is selected/unselected */
  checkAllParentsSelection(node: TodoItemFlatNode): void {
    let parent: TodoItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  /** Check root node checked state and change it accordingly */
  checkRootNodeSelection(node: TodoItemFlatNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.length > 0 && descendants.every(child => {
      return this.checklistSelection.isSelected(child);
    });
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
  }

  /* Get the parent node of a node */
  getParentNode(node: TodoItemFlatNode): TodoItemFlatNode | null {
    const currentLevel = this.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }


    addNewItem(node: TodoItemFlatNode) {
      const parentNode = this.flatNodeMap.get(node);
      //node.expand_more = true;
      this._database.insertItem(parentNode!, new Sentencia({}),this.treeControl,node);
      var padre = this.getParentNode(node);
      if(padre!=null){
        this.treeControl.collapse(padre);
        this.treeControl.expand(padre);
      }


    }

  editItem(node: TodoItemFlatNode) {
    const nestedNode = this.flatNodeMap.get(node);
    this._database.updateItem(node,nestedNode!,this.dataSource);
    var padre = this.getParentNode(node);
    if(padre!=null){
      this.treeControl.collapse(padre);
      this.treeControl.expand(padre);
    }
   }

    removeItem(node: TodoItemFlatNode) {
      var padre = this.getParentNode(node);
      const nodeItem = this.flatNodeMap.get(node);
      if(padre!=null){
        const padreItem = this.flatNodeMap.get(padre);
        this._database.removeItem(padreItem, nodeItem);
      }else{

        var posicion = 0;
        for(var i=0;i<this.estructura.sentencias.length;i++){
          if(this.estructura.sentencias[i].nombre === nodeItem.nombre){
            posicion = i;
            break;
          }
        }
        this.estructura.sentencias.splice(posicion, 1);
        this._database.setData(this.estructura.sentencias);
      }
      //this.treeControl.expand(node);
    }

    addNewRootItem(){
      //const parentNode = this.flatNodeMap.get(node);
      this._database.insertRootItem();
      //const parentNode = this.flatNodeMap.get(node);
      //this._database.insertItem(parentNode!, new Sentencia({}));
      //this.treeControl.expand(node);
    }

    /** Save the node to database */
    saveNode(node: TodoItemFlatNode) {
      const nestedNode = this.flatNodeMap.get(node);
      this._database.updateItem(nestedNode!, this.newNode,this.dataSource);
      this.newNode = new Sentencia({});
      this.orderStructure(this.dataSource.data);
      this.dataSource.data = [...this.dataSource.data];

    }

    orderStructure(nodos):void{
        if(nodos!=null)
          for(var z=0; nodos.length>z;z++){
            nodos.sort(this.utils.sortAlphaNum);
            //nodos.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
            this.orderStructure(nodos[z].sentencias);
          }
      }

      selectNode(node): void {
        const dialogRef = this.dialog.open(DialogBoxChangeFatherComponent, {
          width: '100%',
          data: {obj:node,action:'Update',dataSource:this.dataSource,flatNodeMap:this.flatNodeMap},
          disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {

          if(result.event=='Update'){
            //this.dialogRef.close({event: 'Modifier'});
            this.dialogRef.close({event: 'Modifier',data:this.original});
          }


        });
      }
}

/**
 * Node for to-do item
 */
